import CounterDetailContainer from "./CounterDetailContainer";

export default CounterDetailContainer;
